import { connect } from 'react-redux';
import { currentClientSelector } from '../CommonSelectors/CommonAreaSelector';
import * as actions from './UpsertAccountModalActions';
import * as selectors from './UpsertAccountModalSelector';
import UpsertAccountModalView from './UpsertAccountModalView';
import { fetchNetWorthData } from '../ContextualSidebar/NetWorthSidebar/NetWorthSidebarActions';

const mapStateToProps = state => ({
  currentClient: currentClientSelector(state),
  currentView: selectors.currentViewSelector(state),
  focusedAccount: selectors.focusedAccountSelector(state),
  visibleAccountTypesStack: selectors.visibleAccountTypesStackSelector(state),
  errors: selectors.errorsSelector(state),
  isSavingAccount: selectors.isSavingAccountSelector(state),
  isDeletingAccount: selectors.isDeletingAccountSelector(state),
  defaultPrincipalOwner: selectors.defaultPrincipalOwnerSelector(state),
  accountTypesDictionary: selectors.accountTypesDictionarySelector(state),
  otherAssetTypesDictionary: selectors.otherAssetTypesDictionarySelector(state),
  isFocusedAccountNew: selectors.isFocusedAccountNewSelector(state),
  isConfirmationModalOpen: selectors.isConfirmationModalOpenSelector(state),
  redirectUrl: selectors.redirectUrlSelector(state),
  isFocusedAccountEditable: selectors.isFocusedAccountEditableSelector(state),
});

const mapDispatchToProps = {
  setCurrentView: actions.setCurrentView,
  setFocusedAccount: actions.setFocusedAccount,
  pushVisibleAccountTypes: actions.pushVisibleAccountTypes,
  popVisibleAccountTypes: actions.popVisibleAccountTypes,
  onDeleteAccount: actions.deleteAccount,
  onSaveAccount: actions.saveAccount,
  setErrors: actions.setErrors,
  setIsConfirmationModalOpen: actions.setIsConfirmationModalOpen,
  fetchNetWorthData,
};

export default connect(mapStateToProps, mapDispatchToProps)(UpsertAccountModalView);
